export default __webpack_public_path__ + "static/media/check-mark.7f4755f7.svg";